import React, { useEffect, useState } from 'react';
import Dialog from './Dialog/Dialog';
import { PopButton, PopDivider, PopPanel, PopSlider, PopToggle, PopWell } from './Dialog/PopParts';
import Icona from './Icona/Icona';
import { globalVars } from '../App';
import { setValue } from '../firebase';
import { chooseLite, isLite, onQualityChange } from './Stage/quality';


//cursore del volume con valore in percentuale
const VolumeSlider = ({ id, label, value, onChange, onCommit }) => {
    const safe = Number.isFinite(value) ? value : 1;
    return (
        <div className='pop-slider-field'>
            <div className='pop-range-label'>
                <label htmlFor={id} className='pop-range-name'>{label}</label>
                <span className='pop-range-val'>{Math.round(safe * 100)}%</span>
            </div>
            <PopSlider id={id} value={safe} min={0} max={1} step={0.01} onChange={onChange} onCommit={onCommit} />
        </div>
    );
}

//volume salvato su questo dispositivo (0 è un valore valido), null se assente
const storedVolume = (key) => {
    const val = parseFloat(localStorage.getItem(key));
    return Number.isFinite(val) ? val : null;
}

//inGame: solo la schermata di partita lo passa. Fuori dalla partita (Home) codice e tipo dell'ultima stanza
//restano in globalVars: senza questo controllo il pulsante tornato alla Home scriverebbe i volumi nella vecchia stanza
const SettingsDialog = ({ settings, showSettings, guide, showGuide, options, inGame = false }) => {
    const [clearData, setClearData] = useState(false);
    const remoteBtn = inGame && globalVars.type === "b" && !!globalVars.code;
    const remoteDisp = inGame && globalVars.type === "d" && !!globalVars.code;
    //modalità lite dello sfondo della partita (Stage/quality.js): vale solo per questo dispositivo, quindi a differenza dei
    //volumi non passa dal database. Il pulsante in partita non ha lo sfondo e non la vede; fuori dalla partita il ruolo
    //non è ancora deciso. Il toggle segue anche i verdetti automatici, presi mentre il display gioca
    const [lite, setLite] = useState(isLite);
    const showLite = !(inGame && globalVars.type === "b");

    useEffect(() => onQualityChange(() => setLite(isLite())), []);

    useEffect(() => {
        if(settings) {
            setLite(isLite());
            setTimeout(async () => {
                let d = document.querySelector("#settings-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");

                if(!remoteDisp) {
                    const music = storedVolume("music");
                    const effects = storedVolume("effects");
                    if(music !== null) {
                        options.setMusicVolume(music);
                    }
                    if(effects !== null) {
                        options.setEffectsVolume(effects);
                    }
                }

                //collegato come pulsante: riallinea i volumi del display a quelli salvati qui
                if(remoteBtn) {
                    ["music", "effects"].forEach((key) => {
                        const val = storedVolume(key);
                        if(val !== null) {
                            setValue(globalVars.code+"/"+key, val);
                        }
                    });
                }
            }, 10);
        }
    }, [settings]);

    useEffect(() => {
        if(clearData) {
            setTimeout(() => {
                let d = document.querySelector("#clear-dialog");
                d.style.opacity = null;
                d.classList.add("fade-in");
            }, 10);
        }
    }, [clearData]);

    const closePopup = (id, hide) => {
        let d = document.getElementById(id);
        d.classList.remove("fade-in")
        d.style.opacity = null;
        d.classList.add("fade-out");

        setTimeout(() => {
            hide(false);
        }, 100);
    }

    //key: "music" | "effects" (stesse chiavi di localStorage e del database)
    //durante il trascinamento aggiorna solo questo dispositivo
    const updateVolume = (key, value, _setValue) => {
        const val = parseFloat(value);
        const safeVal = Number.isFinite(val) ? val : 1;
        _setValue(safeVal);
        localStorage.setItem(key, safeVal);
    }

    //al rilascio del cursore invia il valore al display (un solo evento invece di uno per ogni passo)
    const sendVolume = (key, value) => {
        const val = parseFloat(value);
        if(remoteBtn && Number.isFinite(val)) {
            setValue(globalVars.code+"/"+key, val);
        }
    }

    return (
        settings ? (
            <>
            <Dialog
                id="settings-dialog"
                title="Impostazioni"
                icon="gear"
                common={() => {
                    closePopup("settings-dialog", showSettings);
                }}
            >
                <PopWell>
                    <span className='pop-cap'>Audio</span>
                    {remoteBtn && <PopPanel className='pop-alert'>
                        <Icona kind="tv" size={38}/>
                        <span className='pop-txt'>Sei collegato come <b>pulsante</b>: stai regolando i volumi del display.</span>
                    </PopPanel>}
                    <VolumeSlider
                        id="music-slider"
                        label="Musica"
                        value={options.musicVolume}
                        onChange={(v) => updateVolume("music", v, options.setMusicVolume)}
                        onCommit={(v) => sendVolume("music", v)}
                    />
                    <VolumeSlider
                        id="effects-slider"
                        label="Effetti"
                        value={options.effectsVolume}
                        onChange={(v) => updateVolume("effects", v, options.setEffectsVolume)}
                        onCommit={(v) => sendVolume("effects", v)}
                    />
                </PopWell>

                {showLite && <PopWell>
                    <span className='pop-cap'>Grafica</span>
                    <PopToggle on={lite} onClick={() => chooseLite(!lite)}>Modalità lite</PopToggle>
                </PopWell>}

                <PopWell>
                    {showGuide && <PopButton id="guideBtn" color="fire" gIcon="book" onClick={() => showGuide(true)}>
                        Come giocare
                    </PopButton>}
                    {showGuide && <PopDivider/>}
                    <PopButton id="clearData" color="red" gIcon="trash" onClick={() => setClearData(true)}>
                        Elimina dati
                    </PopButton>
                </PopWell>
            </Dialog>

            {clearData && <Dialog
                id="clear-dialog"
                title="Eliminare tutti i dati?"
                icon="trash"
                plate="red"
                cancel={() => {
                    closePopup("clear-dialog", setClearData);
                }}
                confirm={() => {
                    localStorage.clear();
                    window.location.reload();
                }}
                canConfirm={true}
                confirmDestructive={true}
                confirmTxt="Elimina"
                confirmIcon="trash"
            >
                <PopWell>
                    <div className='pop-alert'>
                        <Icona kind="warn" size={56}/>
                        <span className='pop-txt'>Sei sicuro di voler eliminare <b>tutti i dati del gioco</b> salvati su questo dispositivo?</span>
                    </div>
                    <span className='pop-cap' style={{ marginTop: "4px" }}>Verranno cancellati</span>
                    <div className='pop-chips'>
                        <span className='pop-chip'>Le mie squadre</span>
                        <span className='pop-chip'>Parole personalizzate</span>
                    </div>
                    <span className='pop-note'>L'applicazione sarà riavviata.</span>
                </PopWell>
            </Dialog>}
            </>
        ) : (
            <></>
        )
    );
};

export default SettingsDialog;
